import { render, staticRenderFns } from "./BerkleyPolicyDetailActions.vue?vue&type=template&id=c39e6a76"
import script from "./BerkleyPolicyDetailActions.vue?vue&type=script&lang=js"
export * from "./BerkleyPolicyDetailActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports